import React from 'react';
import '../style/appFormRefSettings.css'
import '../style/formGroupTextInput.css'
import InfoLabel from "./infoLabel";
import ExpandableTextarea from "./General/ExpandableTextArea";
import parse from 'html-react-parser';
import {AMOUNT_TRIGGER_AREA_INFO_MESSAGE} from "../helpers/constants";


const TableRow = (props) => {
    let checked = props.HandleCheckedState(props.Question.id);
    const infoMessageText = parse(AMOUNT_TRIGGER_AREA_INFO_MESSAGE);
    return (
        <tr className={"appFormRefSettings-tr "}>
            <td>
                {props.Question.isParent === true && !props.Question.inEveryApplication ?
                    <div>
                        <input id={props.Question.id + 'referralRow'} type="checkbox"
                               className="appFormRefSettings-check_box" checked={checked}
                               onChange={(evt) => props.HandleCheckBoxChange(evt, props.Question)}/>
                        <label htmlFor={props.Question.id + 'referralRow'}></label>
                    </div>

                    :
                    null
                }
            </td>
            <td>
                {props.Question.isParent === true ?
                    <div>
                        {
                            props.Question.isRequired ?
                                <div className=""><span>{props.Question.name}</span><span
                                    className="appFormRefSettings-required">*</span></div>
                                :
                                <div className=""><span>{props.Question.name}</span></div>

                        }

                    </div>
                    :
                    <div>
                        {
                            props.Question.isRequired ?
                                <div><span
                                    className="appFormRefSettings-child-question">{props.CalculateChildQuestionOptionName(props.Question.id)}</span><span>{' - ' + props.Question.name}</span><span
                                    className="appFormRefSettings-required">*</span></div>
                                :
                                <div><span
                                    className="appFormRefSettings-child-question">{props.CalculateChildQuestionOptionName(props.Question.id)}</span>{' - ' + props.Question.name}
                                </div>
                        }

                    </div>

                }
            </td>
            <td>{props.Question.inputType}</td>
            <td>
                {
                    (props.Question.options !== null && (props.Question.inputType !== 'calendar')) ?
                        <ul className="appFormRefSettings-ul">
                            {props.Question.options.map(option => {
                                return <li key={option.id}>{option.name}</li>
                            })}

                        </ul>
                        :
                        null
                }
            </td>
            <td>
                {
                    props.Question.allowTriggers ?
                        <div>
                            {
                                <ExpandableTextarea
                                    type={'text'}
                                    rows={5}
                                    scrollHeight={500}
                                    value={props.Trigger ? props.Trigger.tuw : ''}
                                    className="app-form__textarea-input col-sm-12"
                                    name="tuw"
                                    onChange={(evt) => {
                                        props.ChangeQuestionTrigger(
                                            props.Question.id,
                                            evt.target.name,
                                            evt.target.value,
                                            props.Question
                                        )
                                    }
                                    }
                                />
                            }
                        </div>
                        :
                        <strong>{props.Trigger.tuw}</strong>
                }
            </td>
            <td>
                {
                    props.Question.allowTriggers ?
                        <div>
                            {
                                <ExpandableTextarea
                                    rows={5}
                                    scrollHeight={500}
                                    value={props.Trigger ? props.Trigger.cmu : ''}
                                    className="app-form__textarea-input col-sm-12"
                                    name="cmu"
                                    onChange={(evt) => {
                                        props.ChangeQuestionTrigger(
                                            props.Question.id,
                                            evt.target.name,
                                            evt.target.value,
                                            props.Question
                                        )
                                    }
                                    }
                                />
                            }
                        </div>
                        :
                        <strong>{props.Trigger.cmu}</strong>
                }
                {
                    props.Question.inputType === 'calendar' ?
                        <div className="appFormRefSettings-tr-info">
                            <InfoLabel
                                Value={'Referral trigger can be a combination of: An integer indicating number of weeks from today and a date in dd/mm/yyyy format.'}
                                infoState={props.infoState[props.Question.id]} Name={props.Question.id}
                                onMouseOverHandler={props.changeRefSettingsInfoState}/>
                        </div>
                        :
                        (props.Question.inputType === 'amount' ?
                        <div className="appFormRefSettings-tr-info">
                            <InfoLabel                                
                                Value={infoMessageText}
                                infoState={props.infoState[props.Question.id]} Name={props.Question.id}
                                onMouseOverHandler={props.changeRefSettingsInfoState}/>
                        </div> : null
                        )
                }
            </td>
        </tr>
    )
}

export default TableRow;